import isUndefined from 'lodash/isUndefined';
import { createSelector } from 'reselect';

import { RootState } from 'src/config/rootStore';

export const getAssessmentsState = (state: RootState) => state.assessments;
export const getAssessments = (state: RootState) => state.assessments.assessments;
export const getScores = (state: RootState) => state.assessments.scores;

export const getMostRecentAssessmentDate = (state: RootState) =>
    state.assessments.mostRecentAssessmentDate;

export const getWho5Score = createSelector(getAssessmentsState, ({ scores }) =>
    isUndefined(scores.who5) ? -1 : scores.who5,
);

export const getWho5ScoreFetched = createSelector(
    getAssessmentsState,
    ({ scores }) => !isUndefined(scores.who5),
);
